<template>
  <div class="cnt-head">
    <div class="test container">
      <b-col class="uno">
        <div class="left">
          <div>
            <img class="img" src="@/assets/img/private/growth (2).png" alt="" />
          </div>
          <div class="text">
            <h4 class="titles" style="font-weight: 600;">Perfil:</h4>
            &nbsp;
            <h4 class="titles">SuperAdministrador</h4>
          </div>
        </div>
      </b-col>
      <b-col class="uno">
        <h4 class="titles" style="font-weight: 600;">Ministerio:</h4>
        &nbsp;
        <h4 class="titles">{{ ministerio }}</h4></b-col
      >
      <b-col class="uno">
        <h4 class="titles" style="font-weight: 600;">Servicio:</h4>
        &nbsp;
        <h4 class="titles">{{ servicio }}</h4></b-col
      >
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      ministerio: "",
      servicio: "",
    };
  },
  async mounted() {
    const idServicio = this.$route.params.idServicio;
    if (!idServicio) return;

    try {
      const res = await axios.get(
        `${process.env.VUE_APP_RUTA_API}/instituciones/servicios/${idServicio}/retrieve_public`
      );
      this.ministerio = res.data.ministerio.nombre;
      this.servicio = res.data.nombre;
    } catch (error) {
      console.log(error);
    }
  },
};
</script>
<style scoped>
.cnt-head {
  margin: 0;
  background: #24c6ab;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.test {
  display: flex;
  justify-content: center;
  align-items: center;
}
.uno {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 30%;
}

.dos {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20%;
}
.tres {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50%;
}

.left {
  display: inline-flex;
}

.text {
  color: #052333;
  display: flex;
  align-items: center;
  margin-left: 20px;
}

.img {
  width: 55px;
}

.titles {
  font-weight: 350;
  color: #052333;
  margin: 0 !important;
  text-align: center;
  font-size: 16px;
}

@media screen and (max-width: 597px) {
  .img {
    width: 50px;
  }

  .titles {
    font-size: 14px;
  }
}

@media screen and (max-width: 434px) {
  .img {
    display: none;
  }

  .titles {
    font-size: 12px;
  }
}
</style>
